import React from 'react';
import ContentLoader from 'react-content-loader';

const ReviewContentLoader = ({ count = 1 }) => {
	return (
		<>
			{Array.from({ length: count }).map((_, index) => (
				<ContentLoader
					speed={2}
					width='100%'
					height={140}
					backgroundColor='#f3f3f3'
					foregroundColor='#ecebeb'
					key={index}>
					{/* Stars */}
					<rect x='10' y='15' rx='3' ry='3' width='80' height='15' />

					{/* Username */}
					<rect x='10' y='35' rx='3' ry='3' width='100' height='10' />

					{/* Date */}
					<rect x='90%' y='35' rx='3' ry='3' width='40' height='10' />

					{/* Review text line 1 */}
					<rect x='10' y='55' rx='3' ry='3' width='90%' height='10' />
					{/* Review text line 2 */}
					<rect x='10' y='70' rx='3' ry='3' width='85%' height='10' />
					{/* Review text line 3 */}
					<rect x='10' y='85' rx='3' ry='3' width='80%' height='10' />

					{/* Product images */}
					<rect x='10' y='105' rx='3' ry='3' width='50' height='50' />
					<rect x='70' y='105' rx='3' ry='3' width='50' height='50' />
					<rect x='130' y='105' rx='3' ry='3' width='50' height='50' />
					<rect x='190' y='105' rx='3' ry='3' width='50' height='50' />
					<rect x='250' y='105' rx='3' ry='3' width='50' height='50' />
					<rect x='310' y='105' rx='3' ry='3' width='50' height='50' />
				</ContentLoader>
			))}
		</>
	);
};

export default ReviewContentLoader;
